/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from "react";
import landmarkicon from "../../assets/images/landmarkicon.svg";
import mailicon from "../../assets/images/mailicon.svg";
import logo from "../../assets/images/companylogo.png";
import phoneIcon from "../../assets/images/phone-call.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../routes";
import Login from "../../Components/Login";
import Register from "../../Components/Registration";
import ForgotPassword from "../../Components/ForgotPassword";
import ResetPassword from "../../Components/ResetPassword";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const trackPhoneClick = (eventName: string) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, {
      event_category: "Phone",
      event_label: eventName,
    });
  }
};

interface Props {
  products: any;
  fromPage?: string;
}

const LandingPageHeader: FC<Props> = ({ products, fromPage }: Props) => {
  const [showModal, setShowModal] = useState<string>("");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [registerData, setRegisterData] = useState<any>(null);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(useLocation().search);
  const isReset = queryParams.get("isReset");

  const navbarRef = useRef<HTMLElement | null>(null);

  const closeNavbar = (event: MouseEvent) => {
    if (
      navbarRef.current &&
      !(navbarRef.current as HTMLElement).contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeNavbar);

    return () => {
      document.removeEventListener("click", closeNavbar);
    };
  }, []);

  const handleModal = (value: string) => {
    setShowModal(value);
  };

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const handleRegisterData = (data: any) => {
    setRegisterData(data);
  };

  useEffect(() => {
    if (isReset) {
      handleModal("resetPassword");
    }
  }, []);

  return (
    <>
      <div className="top-info-navbar text-white">
        <div className="container d-flex justify-content-between align-items-center">
          <ul className="list-unstyled mb-0 d-flex align-items-center">
            <li className="d-flex align-items-center me-3">
              <img src={landmarkicon} alt="Location icon" className="me-2" />
              <span className="c-nav-link text-white">
                16 Walnut Street, Middletown, Maryland
              </span>
            </li>
            <li className="d-flex align-items-center">
              <a
                href="mailto:info@skyazul.com"
                className="c-nav-link text-white text-decoration-none"
              >
                <img src={mailicon} alt="Email icon" className="me-2" />
                <span className="c-nav-link text-white">info@skyazul.com</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="top-navbar">
        <div className="container d-flex flex-wrap align-items-center">
          <div className="image-block">
            <img
              src={logo}
              alt="SkyAzul company logo"
              onClick={() => navigate(ROUTES.HOME)}
              className="logo img-cursor"
            />
          </div>
          <ul className="list-unstyled ms-auto mb-0 d-flex pe-3">
            <li className="d-flex align-items-center me-152">
              <img src={phoneIcon} alt="Phone icon" className="me-2" />
              <div className="display">
                <p className="cmn-txt mb-0">Phone Services</p>
                <h4 className="block-title block-title-md mb-0">
                  <a
                    href="tel:3013716126"
                    onClick={() => trackPhoneClick("phone_number_1_clicked")}
                  >
                    (301) 371-6126
                  </a>
                </h4>
                <h4 className="block-title block-title-md mb-0">
                  <a
                    href="tel:2812013690"
                    onClick={() => trackPhoneClick("phone_number_2_clicked")}
                  >
                    (281) 201-3690
                  </a>
                </h4>
              </div>
              <div className="display1">
                <p className="cmn-txt mb-0">Phone Services</p>
                <div className="d-flex align-items-center">
                  <h4 className="block-title block-title-md mb-0">
                    <a
                      href="tel:3013716126"
                      onClick={() => trackPhoneClick("phone_number_1_clicked")}
                    >
                      (301) 371-6126
                    </a>
                  </h4>
                  <h4 className="block-title block-title-md mb-0">
                    <a
                      href="tel:2812013690"
                      onClick={() => trackPhoneClick("phone_number_2_clicked")}
                    >
                      (281) 201-3690
                    </a>
                  </h4>
                </div>
              </div>
            </li>
          </ul>
          <nav
            className="navbar navbar-expand-lg navbar-light w-100"
            ref={navbarRef}
          >
            <div className="container-fluid px-0 h-100">
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleNavbar}
                data-toggle="collapse"
                data-target="#navbarTogglerDemo01"
                aria-controls="navbarTogglerDemo01"
                aria-expanded={isOpen ? "true" : "false"}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div
                className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
                id="navbarTogglerDemo01"
              >
              </div>
            </div>
          </nav>
        </div>
      </div>

      {showModal === "login" && (
        <Login
          show={showModal === "login"}
          handleModal={handleModal}
          handleRegisterData={handleRegisterData}
        />
      )}
      {showModal === "register" && (
        <Register
          show={showModal === "register"}
          handleModal={handleModal}
          handleSocialData={registerData}
        />
      )}
      {showModal === "forgotPassword" && (
        <ForgotPassword
          show={showModal === "forgotPassword"}
          handleModal={handleModal}
        />
      )}
      {showModal === "resetPassword" && (
        <ResetPassword
          show={showModal === "resetPassword"}
          handleModal={handleModal}
        />
      )}
    </>
  );
};

export default React.memo(LandingPageHeader);
